var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.418 20.8438H22.418V22.6562H14.418V20.8438ZM10.418 20.8438H12.418V22.6562H10.418V20.8438ZM14.418 16.3125H22.418V18.125H14.418V16.3125ZM10.418 16.3125H12.418V18.125H10.418V16.3125ZM14.418 11.7812H22.418V13.5938H14.418V11.7812ZM10.418 11.7812H12.418V13.5938H10.418V11.7812Z",
    fill: "#0761AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.418 4.53125H22.418V3.625C22.418 3.1443 22.2073 2.68328 21.8322 2.34337C21.4571 2.00346 20.9484 1.8125 20.418 1.8125H12.418C11.8875 1.8125 11.3788 2.00346 11.0038 2.34337C10.6287 2.68328 10.418 3.1443 10.418 3.625V4.53125H7.41797C6.88754 4.53125 6.37883 4.72221 6.00376 5.06212C5.62868 5.40203 5.41797 5.86305 5.41797 6.34375V25.375C5.41797 25.8557 5.62868 26.3167 6.00376 26.6566C6.37883 26.9965 6.88754 27.1875 7.41797 27.1875H25.418C25.9484 27.1875 26.4571 26.9965 26.8322 26.6566C27.2073 26.3167 27.418 25.8557 27.418 25.375V6.34375C27.418 5.86305 27.2073 5.40203 26.8322 5.06212C26.4571 4.72221 25.9484 4.53125 25.418 4.53125ZM12.418 3.625H20.418V7.25H12.418V3.625ZM25.418 25.375H7.41797V6.34375H10.418V9.0625H22.418V6.34375H25.418V25.375Z",
    fill: "#0761AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListResult);
export default __webpack_public_path__ + "static/media/list-result.94f4916d.svg";
export { ForwardRef as ReactComponent };